import { put, takeLatest } from "redux-saga/effects";
import { requestRentalBillsList } from "services/acclgl/rental-bills";
import {
  fetchgenerateRentalInvoiceListRequest,
  fetchgenerateRentalInvoiceListSuccess,
  fetchgenerateRentalInvoiceListFailure,
} from "redux/reducers/acclgl/generateRentalInvoice";
export function* watchGenerateRentalInvoiceSaga() {
  yield takeLatest(
    fetchgenerateRentalInvoiceListRequest,
    fetchgenerateRentalInvoiceList
  );
}

function* fetchgenerateRentalInvoiceList({ payload }) {
  try {
    const response = yield requestRentalBillsList(payload);
    yield put(fetchgenerateRentalInvoiceListSuccess(response));
  } catch (error) {
    yield put(fetchgenerateRentalInvoiceListFailure("Failed to get list "));
  }
}
